import React from 'react'
import { Input } from 'valuelink/tags'
import { Fade } from '@/components/animations/Fade'
import { LinkedComponent } from 'valuelink'

class FormFields extends LinkedComponent {
  constructor ( props ){
    super( props )
    this.state = {
      touched: false,
      hasValue: false
    }
    this.onFocus = this.onFocus.bind( this )
    this.getClasses = this.getClasses.bind( this )
    this.onBlur = this.onBlur.bind( this )
  }

  componentDidMount () {
    if( this.props.hint || !!this.props.valueLink.value ){
      this.setState( {
        touched: true
      } )
    }
  }
  
  onBlur ( e ) {
    e.preventDefault()
    const hasValue = e.target.value !== '' ? true : false || this.props.hint
    this.setState( {
      touched: hasValue ? true : false, 
      hasValue: hasValue
    } )
  }

  onFocus ( e ) {
    e.preventDefault()
    this.setState( {
      touched: true
    } )
  }

  getClasses ( defaultClass ) {
    let classes = defaultClass
    const { valueLink } = this.props
    if( ( valueLink && valueLink.error ) && this.state.touched ) {
      classes += ' touched error'
    } else if ( this.state.touched ) {
      classes += ' touched'
    }
    return `${classes} ${this.props.className || ''}`
  }


  render () {
    const className = this.getClasses( this.props.float ? 'float-label-input' : 'input-text' )
    return (
      <React.Fragment>
        {this.props.float ? (

          // eslint-disable-next-line jsx-a11y/label-has-for
          <label className={className} htmlFor={this.props.id}>
            <span className="float-label">
              {this.props.placeholder}
            </span>
            <div className="input-container">
              {this.props.icon &&
                <span>
                  <i className="material-icons">{this.props.icon}</i>
                </span>
              }
              <Input { ...this.props}
                placeholder={this.props.hint}
                onFocus={this.onFocus}
                onBlur={this.onBlur}/>
            </div>
            {}
            <Fade in={this.props.valueLink.error && this.state.touched }
              className="form-errors">
              { this.props.valueLink.error || ''}
            </Fade>
          </label>

        ): (

          <div className={className}>
            {this.props.icon && 
              <span>
                <i className="material-icons">{this.props.icon}</i>
              </span>
            }
            <Input { ...this.props} onFocus={this.onFocus}/>
            <Fade in={this.props.valueLink.error && this.state.touched }
              className="form-errors">
              { this.props.valueLink.error || ''}
            </Fade>
          </div>

        )}
      </React.Fragment>
    )
  }
}

export {
  FormFields
}


// WEBPACK FOOTER //
// ./src/components/commons/FormFields.js